import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { getMinStdAnnexListOptions } from '@/module/MinimalStandard/model/MinStdQuery';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type MinStdAnnexSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function MinStdAnnexSelectControl<T extends FieldValues>({ ...props }: MinStdAnnexSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(getMinStdAnnexListOptions());

  const options = (data ?? []).map(({ annexNo, title }) => ({ id: annexNo, name: `${annexNo} - ${title}` }));

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
